import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect } from "react-redux"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from "@material-ui/core/Box";
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import { ApplicationState } from "../../redux/reducers";
import { EmbalajeState } from "../../redux/types/embalajeActionTypes";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { IEvent } from "../../interfaces/IEvent";
import NumberField from "../controls/NumberField";
import { useSnackbar } from 'notistack';
import { initialMercancia } from "../../redux/reducers/mercanciaReducer";
import { IParametro } from "../../redux/types/parametroActionTypes";
import { enums } from "../../enums/enums";
import * as utility from "../../blocks/utility";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from "../controls/SubmitButton";
import { ICliente } from "../../entities/catalogos/ICliente";
import { setSolicitudCopia } from "../../redux/actions/solicitudActions";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Mercancia, IMercancia } from "../../entities/solicitudes/Mercancia";
import useCommonApi from '../../api/useCommonApi';
import swal from 'sweetalert2';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import AutocompleteControl, { IAutocomplete } from "../controls/AutocompleteControl";


interface OwnProps {
    value: Mercancia[]
    siguienteTab: (mercancias: Mercancia[]) => void;
     unidadesData: any[];
}

interface StateProps {
    cliente: ICliente
    solicitudCopia: Solicitud
    embalajes: EmbalajeState[]
    parametros: IParametro[]
}

interface DispatchProps {
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = OwnProps & StateProps & DispatchProps

const MercanciaLista = ({ value, embalajes, cliente, solicitudCopia, setSolicitudCopia, parametros, siguienteTab,unidadesData }: Props) => {
    const [mercancias, setMercancias] = useState<Mercancia[]>(value);
    const { enqueueSnackbar } = useSnackbar();
    const commonWidth = { width: "10%" };
    const metroPulgada = utility.getValorParametro(parametros, 'metroPulgada');
    let kiloLibra = utility.getValorParametro(parametros, 'kilogramoLibra');
    kiloLibra = parseFloat(kiloLibra.toFixed(4));
    const [claseId, setClaseId] = useState(0);
    const apiSource = useCommonApi();
    const [clases, setClases] = useState<any[]>([]);
    const [valorNoEstibable, setValorNoEstibable] = useState(0);
    const [valorMinimoNoEstibable, setValorMinimoNoEstibable] = useState(0);
    const valorMinimoObject= parametros?.find(a=> a.nombre==='Valor mínimo peso unitario');
    const [isDisabledUnidad, setIsDisabledUnidad] = useState(false);
    const [vUnidades, setVUnidades] = useState<any[]>(() => {
        const unidades = JSON.parse(localStorage.getItem("unidades") || "[]");
        return Array.isArray(unidades) ? unidades : [];
    });

    useEffect(() => {
        getClases().then(res => {
            if (res.length) {
                setClases(res);
            }
        });

        if (solicitudCopia.claseId !== undefined && solicitudCopia?.claseId > 0) {
            setClaseId(solicitudCopia.claseId);
        }

        if (parametros.length) {
            setValorNoEstibable(Number(parametros.filter(s => s.id === 36)[0]['valor']));
            setValorMinimoNoEstibable(Number(parametros.filter(s => s.id === 39)[0]['valor']));
        }
        
         const copiaMercancias = mercancias.map(mercancia => {
           const nuevaMercancia = new Mercancia(mercancia);
           nuevaMercancia.disabled = !!mercancia.skuID && mercancia.skuID > 0;
           return nuevaMercancia;
        });
 
        setMercancias(copiaMercancias);
        DisableUnidades(mercancias);
        procesarUnidades();


    }, []);

    const getClases = async () => {
        const result = await apiSource.obtenerAsync<any>("/clase/active");
        return result;
    };



    const handleTipoUnidad = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        const nuevaCotizacion = new Solicitud({ ...solicitudCopia, [name]: Number(value) });
        setSolicitudCopia(nuevaCotizacion);

        const copiaMercancias: Mercancia[] = [];

        mercancias.forEach(m => {
            const copiaMercancia = new Mercancia(m);
            copiaMercancia.ConvertirValores(name, Number(value), metroPulgada, kiloLibra);
            if (name !== "unidadMedidaLongitudId")
                copiaMercancia.CalcularVolumen(Number(solicitudCopia.unidadMedidaLongitudId), Number(metroPulgada));
            else
                copiaMercancia.CalcularVolumen(Number(value), Number(metroPulgada));

            cambiarAlto(copiaMercancia, "alto", copiaMercancia.alto);
            
            copiaMercancias.push(copiaMercancia)
        });

        setMercancias(copiaMercancias);

    };

    const addMercancia = () => {
        const nuevaMercancia = new Mercancia(initialMercancia);
        nuevaMercancia.id = Math.max(...mercancias.map(m => m.id)) + 1;

        setMercancias([...mercancias, nuevaMercancia]);
    };

    const deleteMercancia = (id: number) => {
        const nuevasMercancias = mercancias.filter(m => m.id !== id);
        setMercancias(nuevasMercancias);
        DisableUnidades(nuevasMercancias);
    };

    const validarMedida = (mercancia: IMercancia, campo: string, valor: any, isLastValue: any): boolean => {
        if (!mercancia.camposParaValidar?.includes(campo) || (!valor && isLastValue === 0 ))
            return true;

        const embalaje = embalajes.find(e => e.id === mercancia.embalajeId);
        const embalajeCliente = cliente.embalajes?.find(e => e.id === mercancia.embalajeId);
        const valorEmbalaje = embalaje ? embalaje[campo] : 0;
        const valorEmbalajeCliente = embalajeCliente ? embalajeCliente[campo] : 0;
        let valorPermitido = valorEmbalajeCliente > valorEmbalaje ? valorEmbalajeCliente : valorEmbalaje;

        if (embalajeCliente === undefined || embalajeCliente === null)
            valorPermitido = valorEmbalaje;
        else
            valorPermitido = valorEmbalajeCliente;

        if (campo === "peso") {
            if (solicitudCopia.unidadMedidaPesoId === enums.unidadMedidaPeso.libras)
                valorPermitido *= kiloLibra;
        }
        else {
            if (solicitudCopia.unidadMedidaLongitudId === enums.unidadMedidaLongitud.pulgadas)
                valorPermitido *= metroPulgada;
        }
        // if (solicitudCopia.unidadMedidaPesoId === enums.unidadMedidaPeso.libras && campo === "peso") {
        //     valorPermitido *= kiloLibra;
        // } else if (solicitudCopia.unidadMedidaLongitudId === enums.unidadMedidaLongitud.pulgadas) {
        //     valorPermitido *= metroPulgada;
        // }

        const esValido = valorPermitido >= valor ? valor>0 ? true :false : false;

        if (!esValido) {

            var EtiquetaEmbalaje;
            var idioma = localStorage.getItem("idioma");
            if(idioma === 'en-US'){

                switch(campo){
                    case "alto": campo = traducirLabel(14); break;
                    case "largo": campo = traducirLabel(173); break;
                    case "ancho": campo = traducirLabel(16); break;
                    case "peso": campo = traducirLabel(229); break;
                }

                EtiquetaEmbalaje = embalaje?.etiquetaEmbalaje?.nombre;
            }
            else{
                EtiquetaEmbalaje = embalaje?.nombre;
            }

            const mensaje = traducirMessage(42).replace('####', campo).replace('#####', EtiquetaEmbalaje).replace('#####', valorPermitido); //`El ${campo} real para el embalaje ${embalaje?.nombre} no puede ser mayor a ${valorPermitido}`;

            swal.fire({
                titleText: traducirMessage(11), // '!Aviso!',
                text: mensaje,
                type: 'error',
            });

            return false;
        }

        if(mercancia.alto != null && mercancia.ancho != null && mercancia.largo != null && !mercancia.volumen)
        {
             swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(329),// 'El Volumen calculado no puede ser igual a cero, por favor verifica las medidas capturadas.',
                type: 'warning',
            })

            return false;
        }

        return true;
    };

    const cambiarAlto = (mercancia: IMercancia, propiedad: string, value) => {
        if (propiedad !== "esEstibable" && propiedad !== "alto") return;

        const esEstibable = propiedad === "esEstibable" && value || mercancia.esEstibable;
        const factorConversion = solicitudCopia.unidadMedidaLongitudId === enums.unidadMedidaLongitud.pulgadas ? metroPulgada : 1;
        const valorMinimoNoEstibableConvert = valorMinimoNoEstibable * factorConversion;
        const valorDefault = valorNoEstibable * factorConversion;

        if (propiedad === "alto") {
            const mantenerAltoReal = esEstibable && !!mercancia.altoReal && mercancia.alto === valorDefault;
            mercancia.altoReal = mantenerAltoReal ? mercancia.altoReal : value;
        }

        if (esEstibable && Number(mercancia.alto) > valorMinimoNoEstibableConvert) {
            mercancia.alto = valorDefault;
            mercancia.altoReal = (mercancia.altoReal ?? 0) > valorDefault ? valorDefault : mercancia.altoReal;

            swal.fire({
                titleText: traducirMessage(11), // '!Aviso!',
                text: traducirMessage(150), // "La mercancía esta marcada como no estibable, el campo alto es mayor a la configuración miníma requerida en los parámetros del sistema, se asignará el valor configurado en los parámetros del sistema.",
                type: 'warning',
            });
        }
    }

    const handleChange = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        const name = event.target.name || "";
        const value = name === "esEstibable" ? event.target.checked : event.target.value;
        const esCampoEmblaje = name === "embalajeId";
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, name, value, 0);

        copiaMercancia[name] = esValido ? value : null;

        if(copiaMercancia.skuSeleccionado == null){
            copiaMercancia.LimpiarCampos(name);

            if (value !== 0 && name === "embalajeId") {
                 copiaMercancia.disabled = false;
            }
        }

        if (value === 0 && name === "cantidad") {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(132), // "Favor de verificar la captura de mercancia.",
                type: 'warning',
            });
            copiaMercancia[name] = undefined;
            return;
        }

        else if (!value && name === "esEstibable") {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(132), // "Favor de verificar la captura de mercancia.",
                type: 'warning',
            });

            if(copiaMercancia.skuSeleccionado != null){
                copiaMercancia.alto = copiaMercancia.skuSeleccionado.alto;
                copiaMercancia.ancho = copiaMercancia.skuSeleccionado.ancho;
                copiaMercancia.largo = copiaMercancia.skuSeleccionado.largo;
                copiaMercancia.skuID = Number(copiaMercancia.skuSeleccionado.clienteSkuId);
            }
            else{
                copiaMercancia.alto = null;
                copiaMercancia.volumen = null;
                copiaMercancia.ancho = null;
                copiaMercancia.largo = null;
                copiaMercancia.skuID = null;    
            }
        } else if (esValido) {
            const embalajeId: any = copiaMercancia['embalajeId'] || 0;
            if (embalajeId === 0 && !esCampoEmblaje && name !== 'cantidad') {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: traducirMessage(115), // "Favor de seleccionar el Embalaje.",
                    type: 'warning',
                });
                return;
            }

            copiaMercancia.CalcularVolumen(Number(solicitudCopia.unidadMedidaLongitudId), Number(metroPulgada));
            cambiarAlto(copiaMercancia, name, value);

            if (esCampoEmblaje) {
                const embalaje = embalajes.find(e => e.id === copiaMercancia.embalajeId);
                copiaMercancia.embalaje = embalaje?.nombre;
                copiaMercancia.etiquetaEmbalaje = embalaje?.etiquetaEmbalaje;         
            }
        }

        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleBlur=(event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia)=> {

        if (valorMinimoObject !== undefined && valorMinimoObject !== null) {
            if (event.target.value !== undefined && event.target.value !== null && event.target.value !== "") {
                const copiaMercancia = new Mercancia(mercancia);
                const peso: number = (event?.target?.value ?? 0) as number;
                let valorMinimoArray = valorMinimoObject["valor"].split('|');
                let pesoMinimo = 0;
                if (solicitudCopia.unidadMedidaPesoId === enums.unidadMedidaPeso.kilos)
                    pesoMinimo = parseFloat(valorMinimoArray[0]);
                else
                    pesoMinimo = parseFloat(valorMinimoArray[1]);

                let mensaje = traducirMessage(284) + pesoMinimo.toString();
                if (peso < pesoMinimo) {
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: mensaje, // "EL PESO MÍNIMO UNITARIO ES DE .",
                        type: 'warning',
                    });
                    copiaMercancia.peso = null;
                    setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
                    return
                }
            }
        }
    }

    const handleAlto = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        if (!mercancia.embalajeId) {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(115), // "Favor de seleccionar el Embalaje.",
                type: 'warning',
            })
            return;
        }

        const value = event.target.value !== undefined ? event.target.value : null;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.alto = value !== null ? Number(value) : null;
        copiaMercancia.CalcularVolumen(Number(solicitudCopia.unidadMedidaLongitudId), Number(metroPulgada));
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const validarAlto = (mercancia: Mercancia) => {
        if (!mercancia.alto){
            if(mercancia.alto !== null ? (Number(mercancia.alto)>0 ? true : false) : true )
                return; 
        } 

        const alto = mercancia.alto;
        const copiaMercancia = new Mercancia(mercancia);
        const esValido =  validarMedida(copiaMercancia, "alto", alto,1);

        copiaMercancia.alto = esValido ? Number(alto) : null;

        if (esValido) {
            cambiarAlto(copiaMercancia, "alto", alto);
            copiaMercancia.CalcularVolumen(Number(solicitudCopia.unidadMedidaLongitudId), Number(metroPulgada));
        }

        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleLargo = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        const value = event.target.value !== undefined ? event.target.value : null;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.largo = value !== null ? Number(value) : null;
        copiaMercancia.CalcularVolumen(Number(solicitudCopia.unidadMedidaLongitudId), Number(metroPulgada));
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const validarLargo = (mercancia: Mercancia) => {
        if (!mercancia.largo){
            if(mercancia.largo !== null ? (Number(mercancia.largo)>0 ? true : false) : true )
                return; 
        } 

        const largo = mercancia.largo;
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, "largo", largo,1);
        copiaMercancia.largo = esValido ? Number(largo) : null;
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleAncho = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: Mercancia) => {
        const value = event.target.value !== undefined ? event.target.value : null;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.ancho = value !== null ? Number(value) : null;
        copiaMercancia.CalcularVolumen(Number(solicitudCopia.unidadMedidaLongitudId), Number(metroPulgada));
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const validarAncho = (mercancia: Mercancia) => {
        if (!mercancia.ancho){
            if(mercancia.ancho !== null ? (Number(mercancia.ancho)>0 ? true : false) : true )
                return; 
        } 

        const ancho = mercancia.ancho;
        const copiaMercancia = new Mercancia(mercancia);
        const esValido = validarMedida(copiaMercancia, "ancho", ancho,1);
        copiaMercancia.ancho = esValido ? Number(ancho) : null;
        setMercancias(mercancias.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleSiguienteTab = () => {
        let muestraError = 0;
        let muestraErrorVolumen = 0;

        mercancias.forEach(m => {
            muestraError = (m.alto || m.ancho || m.largo) === 0 ? muestraError = muestraError + 1 : muestraError
            embalajes.forEach(e => {
                if(m.embalajeId === e.id){
                    if(m.etiquetaEmbalaje === undefined){
                        m.etiquetaEmbalaje = e.etiquetaEmbalaje
                    }
                }
            })

            if (m.alto != null && m.ancho != null && m.largo != null && !m.volumen) {
                muestraErrorVolumen++;
            }
        });
        /* mercancias.map( (m) => 
            (m.alto || m.ancho || m.largo) === 0 ? muestraError = muestraError + 1 : muestraError
        ) */
        if(muestraError>0){
            //const mensaje = "Los campos Alto, Ancho y/o Largo no pueden ser igual a cero.";
            swal.fire({
                titleText: traducirMessage(11), // '!Aviso!',
                text: traducirMessage(285),
                type: 'error',
            }); 
                
        }
        else if (muestraErrorVolumen > 0) {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(329), // 'El Volumen calculado no puede ser igual a cero...'
                type: 'warning',
            });
        }
        else{
            siguienteTab(mercancias);
        }
        
    };


    const handleClase = (event: React.ChangeEvent<{ value: unknown }>) => {
        setClaseId(Number(event.target.value));
        let claseN = clases.find(c => c.id === event.target.value);
        const nuevaCotizacion = new Solicitud({ ...solicitudCopia, ['claseId']: Number(event.target.value), ['clase']: claseN.nombre });
        setSolicitudCopia(nuevaCotizacion);
    };

     const procesarUnidades = () => {
        // Establecer valores por defecto para unidades de peso y medida
        if (vUnidades && vUnidades.length > 0) {
            const pesoUnidades = vUnidades.filter(u => u.tipo_unidad_nombre?.toUpperCase() === "PESO");
            const medidaUnidades = vUnidades.filter(u => u.tipo_unidad_nombre?.toUpperCase() === "MEDIDAS");
            const primerPesoId = pesoUnidades.length > 0 ? pesoUnidades[0].unidad_id : solicitudCopia.unidadMedidaPesoId;
            const primerMedidaId = medidaUnidades.length > 0 ? medidaUnidades[0].unidad_id : solicitudCopia.unidadMedidaLongitudId;

           if((solicitudCopia.unidadMedidaLongitudId === null || solicitudCopia.unidadMedidaLongitudId === 0 || solicitudCopia.unidadMedidaLongitudId === undefined)
            && (solicitudCopia.unidadMedidaPesoId === null || solicitudCopia.unidadMedidaPesoId === 0 || solicitudCopia.unidadMedidaPesoId === undefined))
            {
                 const nuevaCotizacion = new Solicitud({ 
                    ...solicitudCopia, 
                    unidadMedidaPesoId: primerPesoId,
                    unidadMedidaLongitudId: primerMedidaId
                });
                
                setSolicitudCopia(nuevaCotizacion); 

                
            solicitudCopia.unidadMedidaPesoId = primerPesoId;
            solicitudCopia.unidadMedidaLongitudId =  primerMedidaId;
            }
        }
    };

       const pesoUnidades = (vUnidades || []).filter(u =>
            u.tipo_unidad_nombre?.toUpperCase() === "PESO" 
       );

        const medidaUnidades = (vUnidades || []).filter(u =>
            u.tipo_unidad_nombre?.toUpperCase() === "MEDIDAS"
        );

    const handleSku = (event: ChangeEvent<HTMLInputElement> | IEvent, 
        mercancia: Mercancia,
        optionSelected) => { 
        
        const unidadPesoSkuId = cliente.clienteConfiguracionDatosGenericos.unidadPesoSkuId;
        const unidadMedidaSkuId = cliente.clienteConfiguracionDatosGenericos.unidadMedidaSkuId;
        const copiaMercancia = new Mercancia(mercancia);
        copiaMercancia.skuSeleccionado = optionSelected;

        if(optionSelected != null){
           const nuevaCotizacion = new Solicitud({ ...solicitudCopia, ['unidadMedidaLongitudId']: Number(unidadMedidaSkuId), ['unidadMedidaPesoId']: Number(unidadPesoSkuId) });
           setSolicitudCopia(nuevaCotizacion);

            copiaMercancia.embalajeId = Number(optionSelected.embalajeId);
            copiaMercancia.alto = Number(optionSelected.alto);
            copiaMercancia.largo = Number(optionSelected.largo);
            copiaMercancia.ancho = Number(optionSelected.ancho);
            copiaMercancia.peso = Number(optionSelected.peso);
            copiaMercancia.skuID = Number(optionSelected.clienteSkuId);

            const esValidoAlto = mercancia.esEstibable || validarMedida(copiaMercancia, "alto", copiaMercancia.alto,1);
            if(esValidoAlto)
            {
                cambiarAlto(copiaMercancia, "alto", copiaMercancia.alto);
                handleAlto({ target: { name: 'alto', value: String(copiaMercancia.alto) } } as ChangeEvent<HTMLInputElement>, copiaMercancia);
            }
            else
                copiaMercancia.alto = null;

            const esValidoLargo = mercancia.esEstibable || validarMedida(copiaMercancia, "largo", copiaMercancia.largo,1);
            if(esValidoLargo)
                handleLargo({ target: { name: 'largo', value: String(copiaMercancia.largo) } } as ChangeEvent<HTMLInputElement>, copiaMercancia);
            else
                copiaMercancia.largo = null;

            const esValidoAncho = mercancia.esEstibable || validarMedida(copiaMercancia, "ancho", copiaMercancia.ancho,1);
            if(esValidoAncho)
                handleAncho({ target: { name: 'ancho', value: String(copiaMercancia.ancho) } } as ChangeEvent<HTMLInputElement>, copiaMercancia);
            else
                copiaMercancia.ancho = null;    

            //Incluye validacion de peso 
            handleBlur({ target: { name: 'embalajeId', value: String(copiaMercancia.embalajeId) } } as ChangeEvent<HTMLInputElement>, copiaMercancia);
            if(copiaMercancia.peso !== null)
                handleChange({ target: { name: 'embalajeId', value: String(copiaMercancia.embalajeId) } } as ChangeEvent<HTMLInputElement>, copiaMercancia);

             copiaMercancia.disabled = true;
        } else {
            copiaMercancia.skuSeleccionado = null;
            copiaMercancia.skuID = null;
            copiaMercancia.disabled = false;
        }

        const nuevasMercancias = mercancias.map(m => m.id !== copiaMercancia.id ? m : copiaMercancia);
        setMercancias(nuevasMercancias);
        DisableUnidades(nuevasMercancias);
    };

    function DisableUnidades(mercanciasParam: Mercancia[]){
        setIsDisabledUnidad(false);

        mercanciasParam.forEach(m => {
            if(m.skuSeleccionado != null){
                setIsDisabledUnidad(true);
                return;
            }
        });
    }

    return (<>
        <Box display="flex">
            <Box pr={4} pb={3}>
                <FormLabel component="legend">
                    {/* Unidad de Peso */
                        traducirLabel(308)}
                </FormLabel>
                <FormControl component="fieldset" id="unidadPeso">
                    <RadioGroup
                            row
                            name="unidadMedidaPesoId"
                            value={solicitudCopia.unidadMedidaPesoId || ""}
                            onChange={handleTipoUnidad}
                            >
                        {pesoUnidades.map(u => (
                            <FormControlLabel
                            key={u.unidad_id}
                            value={u.unidad_id}
                            label={u.unidad_nombre}
                            control={<Radio color="primary" size="small" />}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Box>

            <Box pr={4} pb={3}>
                <FormLabel component="legend">
                    {/* Unidad de Longitud */
                        traducirLabel(307)}
                </FormLabel>
                <FormControl component="fieldset" id="unidadMedida">
                    <RadioGroup
                            row
                            name="unidadMedidaLongitudId"
                            value={solicitudCopia.unidadMedidaLongitudId || ""} 
                            onChange={handleTipoUnidad}
                            >
                            {medidaUnidades.map(u => (
                                <FormControlLabel
                                key={u.unidad_id}
                                value={u.unidad_id}
                                label={u.unidad_nombre}
                                control={<Radio color="primary" size="small" />}
                                />
                            ))}
                        </RadioGroup>
                </FormControl>
            </Box>

            {!!cliente.esClase &&
                <Box pr={4} pb={3}>
                    <FormLabel component="legend">
                        {/* Clase */
                            traducirLabel(34)}
                    </FormLabel>
                    <FormControl component="fieldset" size="small">
                        <Select fullWidth name="claseId" value={claseId}
                            error={claseId === -1 && cliente.esClase}
                            onChange={handleClase}>
                            <MenuItem value={0} disabled />
                            {clases.map((e) => (
                                <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            }
        </Box>

        <ValidatorForm
            onSubmit={handleSiguienteTab}
        >
            <TableContainer component={Paper}>
                <Table className="table-xs" size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                             {cliente.documentacionSku && solicitudCopia.tipoSolicitud == "solicitud servicio" && (
                                <TableCell align="center" style={{ width: "200px" }}>
                                    {"SKU"}
                                </TableCell>
                            )}
                            <TableCell align="center" style={commonWidth}>
                                {/* Cantidad */
                                    traducirLabel(29)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "25%" }}>
                                {/* Embalaje */
                                    traducirLabel(111)}
                            </TableCell>
                            <TableCell align="center" style={commonWidth}>
                                {/* Alto */
                                    traducirLabel(14)}
                            </TableCell>
                            <TableCell align="center" style={commonWidth}>
                                {/* Alto Real */
                                    traducirLabel(15)}
                            </TableCell>
                            <TableCell align="center" style={commonWidth}>
                                {/* Largo */
                                    traducirLabel(173)}
                            </TableCell>
                            <TableCell align="center" style={commonWidth}>
                                {/* Ancho */
                                    traducirLabel(16)}
                            </TableCell>
                            <TableCell align="center" style={commonWidth}>
                                {/* Peso */
                                    traducirLabel(229)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "11%" }}>
                                {/* Volumen */
                                    traducirLabel(320)}
                            </TableCell>
                            <TableCell align="center" style={commonWidth}>
                                {/* No Estibable */
                                    traducirLabel(190)}
                            </TableCell>
                            <TableCell style={{ padding: 0, width: "4%" }} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mercancias.map((row) => (
                            <TableRow key={row.id}>
                                 {cliente.documentacionSku && solicitudCopia.tipoSolicitud == "solicitud servicio" && (
                                    <TableCell style={{ position: 'relative', top: -10 }}>
                                        <AutocompleteControl name="" source="cliente-sku/skus-por-cliente" minLength={3} label="" width={"200px"} 
                                            value={row.skuSeleccionado ? row.skuSeleccionado : null} 
                                            onChange={(event, selectedOption) => handleSku(event, row, selectedOption)}
                                            filter={{ clienteId: cliente.id }}/>
                                    </TableCell>
                                )}
                                <TableCell>
                                    <TextValidator
                                        value={row.cantidad}
                                        name="cantidad"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 0, maxLength: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Select fullWidth name="embalajeId" value={row.embalajeId} disabled={row.disabled}
                                        onChange={(e) => handleChange({
                                            target: {
                                                name: e.target.name,
                                                value: e.target.value
                                            }
                                        }, row)}>
                                        <MenuItem value={0} disabled />
                                        {localStorage.getItem("idioma") === 'en-US' && embalajes.map((e) => (
                                            <MenuItem key={e.id} value={e.id}>{e.etiquetaEmbalaje.nombre}</MenuItem>
                                        ))}
                                        {localStorage.getItem("idioma") !== 'en-US' && embalajes.map((e) => (
                                            <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>
                                        ))}
                                    </Select>
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.alto}
                                        name="alto"
                                        disabled={row.disabled}
                                        onChange={(e) => handleAlto(e, row)}
                                        onBlur={() => validarAlto(row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.altoReal}
                                        name="altoReal"
                                        errorMessages={[""]}
                                        fullWidth
                                        disabled={true}
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.largo}
                                        name="largo"
                                        disabled={row.disabled}
                                        onChange={(e) => handleLargo(e, row)}
                                        onBlur={() => validarLargo(row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth

                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.ancho}
                                        name="ancho"
                                        disabled={row.disabled}
                                        onChange={(e) => handleAncho(e, row)}
                                        onBlur={() => validarAncho(row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth

                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.peso}
                                        name="peso"
                                        disabled={row.disabled}
                                        onChange={(e) => handleChange(e, row)}
                                        onBlur={(e)=> handleBlur(e, row)}
                                        validators={['required']}
                                        errorMessages={[""]}
                                        fullWidth

                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.volumen}
                                        className="text-right"
                                        disabled={true}
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Checkbox checked={row.esEstibable} size="small"
                                        onChange={(e) => handleChange(e, row)}
                                        name="esEstibable" color="primary" className="check" />
                                </TableCell>

                                <TableCell style={{ padding: "0 5px 0 0" }}>
                                    {mercancias.length > 1 &&
                                        <DeleteIcon color="error" style={{ fontSize: "1rem" }} className="pointer"
                                            onClick={() => deleteMercancia(row.id)} />
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={2} className="text-right">
                <Button color="primary" size="small" startIcon={<AddCircleIcon />} onClick={addMercancia}>
                    {/* Agregar otra Mercancía */
                        traducirLabel(8)}
                </Button>
            </Box>

            <SubmitButton />
        </ValidatorForm>
    </>);
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    solicitudCopia: state.solicitudCopia,
    embalajes: state.embalajes,
    parametros: state.parametros
});

const mapDispatchToProps = {
    setSolicitudCopia: setSolicitudCopia
};

export default connect(mapStateToProps, mapDispatchToProps)(MercanciaLista);
